import { DataGrid, type DataGridProps, type GridValidRowModel } from '@shared/components';

import { columns, type QConfigGeneratorResult } from './column';

type BaseQConfigGeneratorResultListProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridProps<TRowModel>,
  'columns'
>;

export default function BaseQConfigGeneratorResultList(
  props: Readonly<BaseQConfigGeneratorResultListProps<QConfigGeneratorResult>>,
) {
  return (
    <DataGrid
      disableColumnMenu
      {...props}
      columns={columns}
      rowHeight={48}
      hideFooter
      disableRowSelectionOnClick
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '412px',
        '.MuiDataGrid-overlayWrapperInner': {
          display: 'flex',
        },
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2.75),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.grey[100],
        },
      })}
    />
  );
}
